// Test Report Selectors

export const testReportLoading$ = (state) => state.testReport?.loading || false;

export const testReportError$ = (state) => state.testReport?.error || null;

export const currentTestReport$ = (state) => state.testReport?.currentReport || null;

export const userTestReports$ = (state) => state.testReport?.userReports || [];

export const latestTestReport$ = (state) => {
    const reports = state.testReport?.userReports || [];
    return reports.length > 0 ? reports[0] : null;
};

export const testReportById$ = (reportId) => (state) => {
    const reports = state.testReport?.userReports || [];
    return reports.find(report => report._id === reportId) || null;
};